/*
Monotype Foundry Platform API
Version 1.0.0

Definition: FoundryDetails

Properties:
  contractProcessStatus: string
  contractSummary: string
  credibility: string
  defaultContractId: string
  defaultLicenseID: number
  defaultMultiUserSchemeID: number
  defaultVolumeDiscountSchemeID: number
  directory: string
  externalId: string
  financeData: array
  id: string
  isFontDataInPIM: string
  logoUrl: string
  bannerUrl: string
  name: string
  permissions: array
  pimContractSummary: string
  status: string
  visibilityScore: number
  aiAgreement: object
  updatedDate: string
  hasMTFAccess: boolean
  isAdmin: boolean
  terminationDate: string
  contractStatus: string
  previouslyReleasedFamiliesCount: number
*/

var FoundryDetails = (function () {
  function validateFoundryDetails (arg) {
    // Validate contractProcessStatus
    if (arg.contractProcessStatus && !(typeof arg.contractProcessStatus === 'string')) {
      throw new Error('FoundryDetails.contractProcessStatus: Wrong type: Got \'' + (typeof arg.contractProcessStatus) + '\', but expected: \'string\'')
    }
    // Validate contractSummary
    if (arg.contractSummary && !(typeof arg.contractSummary === 'string')) {
      throw new Error('FoundryDetails.contractSummary: Wrong type: Got \'' + (typeof arg.contractSummary) + '\', but expected: \'string\'')
    }
    // Validate credibility
    if (arg.credibility && !(typeof arg.credibility === 'string')) {
      throw new Error('FoundryDetails.credibility: Wrong type: Got \'' + (typeof arg.credibility) + '\', but expected: \'string\'')
    }
    // Validate defaultContractId
    if (arg.defaultContractId && !(typeof arg.defaultContractId === 'string')) {
      throw new Error('FoundryDetails.defaultContractId: Wrong type: Got \'' + (typeof arg.defaultContractId) + '\', but expected: \'string\'')
    }
    // Validate defaultLicenseID
    if (arg.defaultLicenseID && !(typeof arg.defaultLicenseID === 'number')) {
      throw new Error('FoundryDetails.defaultLicenseID: Wrong type: Got \'' + (typeof arg.defaultLicenseID) + '\', but expected: \'number\'')
    }
    // Validate defaultMultiUserSchemeID
    if (arg.defaultMultiUserSchemeID && !(typeof arg.defaultMultiUserSchemeID === 'number')) {
      throw new Error('FoundryDetails.defaultMultiUserSchemeID: Wrong type: Got \'' + (typeof arg.defaultMultiUserSchemeID) + '\', but expected: \'number\'')
    }
    // Validate defaultVolumeDiscountSchemeID
    if (arg.defaultVolumeDiscountSchemeID && !(typeof arg.defaultVolumeDiscountSchemeID === 'number')) {
      throw new Error('FoundryDetails.defaultVolumeDiscountSchemeID: Wrong type: Got \'' + (typeof arg.defaultVolumeDiscountSchemeID) + '\', but expected: \'number\'')
    }
    // Validate directory
    if (arg.directory && !(typeof arg.directory === 'string')) {
      throw new Error('FoundryDetails.directory: Wrong type: Got \'' + (typeof arg.directory) + '\', but expected: \'string\'')
    }
    // Validate externalId
    if (arg.externalId && !(typeof arg.externalId === 'string')) {
      throw new Error('FoundryDetails.externalId: Wrong type: Got \'' + (typeof arg.externalId) + '\', but expected: \'string\'')
    }
    // Validate financeData
    if (arg.financeData && !(Array.isArray(arg.financeData))) {
      throw new Error('FoundryDetails.financeData: Wrong type: Got \'' + (typeof arg.financeData) + '\', but expected: \'array\'')
    }
    // Validate id
    if (arg.id && !(typeof arg.id === 'string')) {
      throw new Error('FoundryDetails.id: Wrong type: Got \'' + (typeof arg.id) + '\', but expected: \'string\'')
    }
    // Validate isFontDataInPIM
    if (arg.isFontDataInPIM && !(typeof arg.isFontDataInPIM === 'string')) {
      throw new Error('FoundryDetails.isFontDataInPIM: Wrong type: Got \'' + (typeof arg.isFontDataInPIM) + '\', but expected: \'string\'')
    }
    // Validate logoUrl
    if (arg.logoUrl && !(typeof arg.logoUrl === 'string')) {
      throw new Error('FoundryDetails.logoUrl: Wrong type: Got \'' + (typeof arg.logoUrl) + '\', but expected: \'string\'')
    }
    // Validate bannerUrl
    if (arg.bannerUrl && !(typeof arg.bannerUrl === 'string')) {
      throw new Error('FoundryDetails.bannerUrl: Wrong type: Got \'' + (typeof arg.bannerUrl) + '\', but expected: \'string\'')
    }
    // Validate name
    if (arg.name && !(typeof arg.name === 'string')) {
      throw new Error('FoundryDetails.name: Wrong type: Got \'' + (typeof arg.name) + '\', but expected: \'string\'')
    }
    // Validate permissions
    if (arg.permissions && !(Array.isArray(arg.permissions))) {
      throw new Error('FoundryDetails.permissions: Wrong type: Got \'' + (typeof arg.permissions) + '\', but expected: \'array\'')
    }
    // Validate pimContractSummary
    if (arg.pimContractSummary && !(typeof arg.pimContractSummary === 'string')) {
      throw new Error('FoundryDetails.pimContractSummary: Wrong type: Got \'' + (typeof arg.pimContractSummary) + '\', but expected: \'string\'')
    }
    // Validate status
    if (arg.status && !(typeof arg.status === 'string')) {
      throw new Error('FoundryDetails.status: Wrong type: Got \'' + (typeof arg.status) + '\', but expected: \'string\'')
    }
    // Validate visibilityScore
    if (arg.visibilityScore && !(typeof arg.visibilityScore === 'number')) {
      throw new Error('FoundryDetails.visibilityScore: Wrong type: Got \'' + (typeof arg.visibilityScore) + '\', but expected: \'number\'')
    }
    // Validate updatedDate
    if (arg.updatedDate && !(typeof arg.updatedDate === 'string')) {
      throw new Error('FoundryDetails.updatedDate: Wrong type: Got \'' + (typeof arg.updatedDate) + '\', but expected: \'string\'')
    }
    // Validate hasMTFAccess
    if (arg.hasMTFAccess && !(typeof arg.hasMTFAccess === 'boolean')) {
      throw new Error('FoundryDetails.hasMTFAccess: Wrong type: Got \'' + (typeof arg.hasMTFAccess) + '\', but expected: \'boolean\'')
    }
    // Validate isAdmin
    if (arg.isAdmin && !(typeof arg.isAdmin === 'boolean')) {
      throw new Error('FoundryDetails.isAdmin: Wrong type: Got \'' + (typeof arg.isAdmin) + '\', but expected: \'boolean\'')
    }
    // Validate terminationDate
    if (arg.terminationDate && !(typeof arg.terminationDate === 'string')) {
      throw new Error('FoundryDetails.terminationDate: Wrong type: Got \'' + (typeof arg.terminationDate) + '\', but expected: \'string\'')
    }
    // Validate contractStatus
    if (arg.contractStatus && !(typeof arg.contractStatus === 'string')) {
      throw new Error('FoundryDetails.contractStatus: Wrong type: Got \'' + (typeof arg.contractStatus) + '\', but expected: \'string\'')
    }
    // Validate previouslyReleasedFamiliesCount
    if (arg.previouslyReleasedFamiliesCount && !(typeof arg.previouslyReleasedFamiliesCount === 'number')) {
      throw new Error('FoundryDetails.previouslyReleasedFamiliesCount: Wrong type: Got \'' + (typeof arg.previouslyReleasedFamiliesCount) + '\', but expected: \'number\'')
    }
  }
  function buildFoundryDetails (arg) {
    var FoundryDetails = arg
    // Complete contractProcessStatus
    // Expected Type: string
    FoundryDetails.contractProcessStatus = FoundryDetails.contractProcessStatus || ''
    // Complete contractSummary
    // Expected Type: string
    FoundryDetails.contractSummary = FoundryDetails.contractSummary || ''
    // Complete credibility
    // Expected Type: string
    FoundryDetails.credibility = FoundryDetails.credibility || ''
    // Complete defaultContractId
    // Expected Type: string
    FoundryDetails.defaultContractId = FoundryDetails.defaultContractId || ''
    // Complete defaultLicenseID
    // Expected Type: number
    FoundryDetails.defaultLicenseID = FoundryDetails.defaultLicenseID || 0
    // Complete defaultMultiUserSchemeID
    // Expected Type: number
    FoundryDetails.defaultMultiUserSchemeID = FoundryDetails.defaultMultiUserSchemeID || 0
    // Complete defaultVolumeDiscountSchemeID
    // Expected Type: number
    FoundryDetails.defaultVolumeDiscountSchemeID = FoundryDetails.defaultVolumeDiscountSchemeID || 0
    // Complete directory
    // Expected Type: string
    FoundryDetails.directory = FoundryDetails.directory || ''
    // Complete externalId
    // Expected Type: string
    FoundryDetails.externalId = FoundryDetails.externalId || ''
    // Complete financeData
    // Expected Type: array
    FoundryDetails.financeData = FoundryDetails.financeData || []
    // Complete id
    // Expected Type: string
    FoundryDetails.id = FoundryDetails.id || ''
    // Complete isFontDataInPIM
    // Expected Type: string
    FoundryDetails.isFontDataInPIM = FoundryDetails.isFontDataInPIM || ''
    // Complete logoUrl
    // Expected Type: string
    FoundryDetails.logoUrl = FoundryDetails.logoUrl || ''
    // Complete bannerUrl
    // Expected Type: string
    FoundryDetails.bannerUrl = FoundryDetails.bannerUrl || ''
    // Complete name
    // Expected Type: string
    FoundryDetails.name = FoundryDetails.name || ''
    // Complete permissions
    // Expected Type: array
    FoundryDetails.permissions = FoundryDetails.permissions || []
    // Complete pimContractSummary
    // Expected Type: string
    FoundryDetails.pimContractSummary = FoundryDetails.pimContractSummary || ''
    // Complete status
    // Expected Type: string
    FoundryDetails.status = FoundryDetails.status || ''
    // Complete visibilityScore
    // Expected Type: number
    FoundryDetails.visibilityScore = FoundryDetails.visibilityScore || 0
    // Complete updatedDate
    // Expected Type: string
    FoundryDetails.updatedDate = FoundryDetails.updatedDate || ''
    // Complete hasMTFAccess
    // Expected Type: boolean
    FoundryDetails.hasMTFAccess = FoundryDetails.hasMTFAccess || false
    // Complete isAdmin
    // Expected Type: boolean
    FoundryDetails.isAdmin = FoundryDetails.isAdmin || false
    // Complete terminationDate
    // Expected Type: string
    FoundryDetails.terminationDate = FoundryDetails.terminationDate || ''
    // Complete contractStatus
    // Expected Type: string
    FoundryDetails.contractStatus = FoundryDetails.contractStatus || ''
    // Complete previouslyReleasedFamiliesCount
    // Expected Type: number
    FoundryDetails.previouslyReleasedFamiliesCount = FoundryDetails.previouslyReleasedFamiliesCount || 0
    return FoundryDetails
  }
  return {
    validate: validateFoundryDetails,
    build: buildFoundryDetails
  }
})()

module.exports = FoundryDetails
